const ExperienceDB = [
  {
    id: "EX0",
    JobRole: "Data Analyst",
    JobType: "Contract",
    StartDay: "March 2025",
    EndDay: "Present",
    Company: "The Analyst Hub",
    Nature: "Remote",
    url: "https://www.theanalysthub.ng/",
    Description: [
      "Built and maintained 15+ interactive Power BI dashboards and automated reporting solutions, analyzing 50,000+ business and operational records using SQL and Excel to give stakeholders real-time visibility into KPIs, performance trends, and strategic business metrics.",
      "Drove data-driven decision-making by executing end-to-end data wrangling, ETL, and validation processes across multiple data sources, improving reporting accuracy by 25% and reducing manual reporting effort by 40%.",
      "Performed trend analysis, variance analysis, segmentation, and KPI tracking on large datasets, uncovering revenue optimization opportunities and operational inefficiencies that contributed to an estimated 15% improvement in process performance.",
      "Collaborated with cross-functional business and technical teams to gather reporting requirements, develop scalable analytical frameworks, and document data workflows and ETL processes, reducing knowledge-transfer gaps by 30% and improving reporting consistency across departments.",
      "Prepared and presented daily, weekly, and monthly performance reports and executive summaries that translated complex data findings into clear, actionable recommendations for senior leadership.",
      "Translated stakeholder requirements into structured analytical approaches and documented findings for clarity and reuse.",
      "Supported workforce planning and budgeting processes by analyzing departmental performance trends and providing management with forward-looking operational insights.",
    ],
  },
  {
    id: "EX122",
    JobRole: "Business Intelligence Analyst",
    JobType: "Freelance",
    StartDay: "January 2023",
    EndDay: "Present",
    Company: "Upwork/Fiverr",
    Nature: "Remote",
    url: "",
    Description: [
      "I worked with clients across different industries, supporting short-term and ongoing data analysis needs. I independently managed projects from data collection through reporting, ensuring accuracy and clarity in all deliverables.",
      "Extracted and analyzed data from SQL databases, Excel files, Google Sheets, and cloud-based sources.",
      "Designed Excel-based analysis workflows using Power Query, PivotTables, formulas, and validation rules to standardize reporting.",
      "Performed descriptive and trend analysis to identify patterns, inefficiencies, and opportunities for improvement.",
      "Conducted data quality checks, reconciliation, and error reviews to maintain reporting accuracy.",
      "Built dashboards and summary reports that translated complex datasets into clear, decision-ready insights.",
      "Managed multiple projects concurrently while meeting deadlines and maintaining high attention to detail.",
    ],
  },
  {
    id: "EX1",
    JobRole: "Data Analyst",
    JobType: "Full Time",
    StartDay: "February 2023",
    EndDay: "March 2025",
    Company: "Accessible Publishers Limited",
    Nature: "Onsite",
    url: "https://www.accessiblepublishers.com/",
    Description: [
      "Built and maintained interactive Power BI dashboards and KPI reporting solutions by analyzing sales and operational datasets, providing leadership with real-time visibility into business performance and improving reporting accuracy by 25% through robust data cleaning, validation, and modeling.",
      "Drove data-driven decision-making by uncovering sales trends, customer purchasing patterns, and product performance insights, contributing to an estimated 15% increase in revenue growth and supporting strategic business planning across departments.",
      "Led the consolidation of data from 5+ business functions into a centralized reporting framework, reducing manual reporting effort by 40% and enabling faster, more reliable access to critical business intelligence.",
      "Collaborated closely with Operations and Finance stakeholders to translate complex data into actionable recommendations, improving reporting consistency by 30% and strengthening overall performance monitoring and business partnership capabilities.",
      "Supported workforce planning and budgeting processes by analyzing departmental performance trends and providing management with forward-looking operational insights.",
      "Improved reporting accuracy by approximately 25% through structured data quality checks and validation processes.",
      "Analyzed data to award recognition to supervisors, staffs, casuals, apprentice for their performance for every month.",
      "Developing automated processes for data scraping.",
    ],
  },
  {
    id: "EX2",
    JobRole: "Quantity Surveyor",
    JobType: "Full Time",
    StartDay: "February 2022",
    EndDay: "March 2025",
    Company: "Best Technologies Limited",
    Nature: "OnSite",
    url: "https://www.besttechnologiesltd.com/",
    Description: [
      "Measure building and civil engineering works, prepare bills of quantities, and manage material schedules and work programs.",
      "I oversee site engineering and procurement of materials and prepare interim valuations",
      "Price un-priced bills of quantities for tendering and procure materials for the site.",
      "I prepare and submit monthly valuations to the client and manage the final account.",
      "I also prepare and submit claims for variations and manage the final account.",
    ],
  },
  {
    id: "EX3",
    JobRole: "Data Analysis Tutor",
    JobType: "Part Time",
    StartDay: "February 2023",
    EndDay: "March 2025",
    Company: "Best Technologies Limited",
    Nature: "Part Time",
    url: "https://www.besttechnologiesltd.com/",
    Description: [
      "Delivered hands-on training in SQL, Python, Excel, and Power BI.",
      "Guided learners through data cleaning, exploratory data analysis, reporting, and dashboard creation.",
      "Demonstrated best practices for data validation, accuracy checks, and analytical thinking.",
      "Supported learners with project guidance, interpretation of results, and presentation of insights.",
      "Developed curriculum covering statistical analysis, data wrangling, data visualization, and ETL concepts, building job-ready analytical skills in each cohort.",
      "Provided personalized mentorship and feedback to help learners build confidence and proficiency in data analysis tools and techniques.",
    ],
  },
  {
    id: "EX4",
    JobRole: "Mentor (Tech4Governance)",
    JobType: "Volunteer",
    StartDay: "September 2024",
    EndDay: "December 2024",
    Company: "Aspilos Foundation",
    Nature: "Remote",
    url: "https://aspilosfoundation.org.ng/",
    Description: [
      "Guided young tech professionals in developing Civic Tech Solutions to address governance challenges.",
      "Provided mentorship on data-driven decision-making and the integration of technology for social impact.",
      "Conducted workshops on data analysis, visualization, and solution prototyping.",
    ],
  },
  {
    id: "EX5",
    JobRole: "FrontEnd Developer",
    JobType: "Volunteer",
    StartDay: "April 2022",
    EndDay: "December 2023",
    Company: "United State of Africa",
    Nature: "Remote",
    url: "https://usafrikagov.com/",
    Description: [
      "I collaborate with designers and back-end developers to implement and maintain user interfaces for the company websites and web applications.",
      "I collaborate with other frontend developers to work on the company website and web applications.",
      "I actively participate in agile development processes, including sprint planning, daily stand-ups, and retrospectives, to ensure timely delivery of high-quality software.",
      "I write clean, efficient, and maintainable code using React JS, Next JS framework with tailwind CSS for the styling.",
      "Worked on implementation of website Figma design.",
      "I ensure cross-browser compatibility and responsiveness of web interfaces across various devices and screen sizes",
      "I implement user interface designs with a keen eye for detail, ensuring visual consistency and adherence to brand guidelines.",
      "I conduct several test and debugging of code to ensure the functionality and integrity of web interfaces.",
      "I also collaborate with cross-functional teams to understand project requirements and deliver high-quality solutions within specified timelines.",
    ],
  },
];

export default ExperienceDB;
